module.exports = __webpack_public_path__ + "6b153086435abe2325e736cd7d1b8cb8.png";


//////////////////
// WEBPACK FOOTER
// ./node_modules/url-loader??ref--8-1!./node_modules/image-webpack-loader??ref--8-2!./node_modules/srcset-loader/lib/resize-loader.js?size=900!./src/components/cover/teaser-dark.png?size=900w
// module id = 39
// module chunks = 1